import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader } from 'src/modules/core/components'
import { SyncOfflineChangesModal } from 'src/modules/user/components/send-test-or-finish/sync-offline-changes-modal/sync-offline-changes-modal'
import { useRequirementsGate } from './use-requirements-gate'

type RequirementsGateProps = {
  path: string
  restricted: boolean
  isAuthenticated: boolean
  children: React.ReactNode
}

export function RequirementsGate({ path, restricted, isAuthenticated, children }: RequirementsGateProps) {
  const navigate = useNavigate()
  const { action, isLoading } = useRequirementsGate({
    path,
    restricted,
    isAuthenticated,
  })

  useEffect(() => {
    if (action.type !== 'redirect' || action.to === path) {
      return
    }

    navigate(action.to, { replace: true })
  }, [action, navigate, path])

  if (isLoading) {
    return <Loader isLoading full />
  }

  if (action.type === 'render' && action.component === 'syncOfflineChangesModal') {
    return <SyncOfflineChangesModal />
  }

  return <>{children}</>
}
